var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAngular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 272,
    viewBox: "0 0 256 272",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0996094 45.5222L125.908 0.697266L255.104 44.7253L234.185 211.175L125.908 271.141L19.3245 211.972L0.0996094 45.5222Z",
    fill: "#E23237"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M255.104 44.7253L125.908 0.697266V271.141L234.185 211.275L255.104 44.7253Z",
    fill: "#B52E31"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M126.107 32.2734L47.7129 206.692L76.9985 206.194L92.737 166.848H126.206H126.306H163.062L180.295 206.692L208.286 207.19L126.107 32.2734ZM126.306 88.1551L152.802 143.539H127.402H126.107H102.997L126.306 88.1551Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngular);
export default __webpack_public_path__ + "static/media/angular.d4cb4fa5908f614ceb0969ed92e02f9c.svg";
export { ForwardRef as ReactComponent };